(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('flashMessage', function($timeout, $filter, resourceService) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: (element, attr) => {
            if (attr.templateVersion) {
                return `partials/booking/template?name=FlashMessage&version=${attr.templateVersion}`;
            }
            const templateName = attr.templateName || 'FlashMessage';
            return `partials/home/directivetemplate?type=${templateName}`;
            },
        link(scope) {
            let err = null;
            let success = null;
            let info = null;

            const tryStopPropagation = function(ev) {
                if (typeof ev.stopPropagation === 'function') {
                    ev.stopPropagation();
                }
            };

            scope.visible = false;

            scope.skywardsLogin = function() {
                let skywards = document.querySelector('.skywards-login-section');
                let errors = document.querySelector('.error-message');
                let cellError = document.querySelector('.form-field-cell .error-message');

                if (skywards) {
                    if (window.innerWidth > 800) {
                        if (skywards && skywards.classList && err) {
                            skywards.classList.add('cpgSkywardsMargin');
                            skywards.style.marginTop = `${errors.clientHeight + 20}px`;
                            errors.classList.remove('ng-hide');
                            cellError.classList.add('ng-hide'); // This is to hide an empty error message under the title from showing.
                        } else if (skywards && skywards.classList && !err) {
                            skywards.classList.remove('cpgSkywardsMargin');
                            setTimeout(() => {
                                skywards.style.marginTop = '';
                            }, 200);
                        }
                    } else {
                        skywards.classList.remove('cpgSkywardsMargin');
                        setTimeout(() => {
                            skywards.style.marginTop = '';
                        }, 200);
                    }
                }
            };

            scope.getClass = function() {
                if (TRPCONFIG.Domain2.CPGIframeUpdate) {
                    let lis = document.querySelectorAll('#booking-form-wrapper ul li')[0];
                    let threeds = document.querySelector('.threeds-wrapper-new');

                    if (lis && err) {
                        let target = document;
                        let observer = new MutationObserver(mutations => {
                                mutations.forEach(() => {
                                    if (!threeds.classList.contains('ng-hide')) {
                                        err = null;
                                        observer.disconnect();
                                    }
                                });
                        });

                        let config = {
                            subtree: true,
                            attributes: true,
                            childList: false,
                            characterData: false
                        };

                        observer.observe(target, config);
                    }

                    scope.skywardsLogin();

                    window.addEventListener('resize', scope.skywardsLogin());
                }
                return (err ? 'error-message' : (success ? 'success-message' : (info ? 'info-message' : 'closed')));
            };

            scope.$on('flash:error', function(ev, msg) {
                err = success = info = null;
                if (msg == null) {
                    return;
                }
                scope.visible = true;
                if (!(msg instanceof Array)) {
                    msg = [msg];
                }
                err = msg;
                scope.message = msg.map(function(m) {
                    if (_.isObject(m)) {
                        //Escape the unexpected backend error:
                        let backendError = $('<div/>').text($filter('json')(m)).html();
                        let errorMessage = resourceService.get('UNEXPECTEDSEARCHERROR');
                        m = `${errorMessage} <span class="ng-hide">${backendError}</span>`;
                    }
                    return `<li>${m}</li>`;
                }).join('');
                tryStopPropagation(ev);
            });

            scope.$on('flash:success', function(ev, msg) {
                scope.message = success = msg;
                scope.visible = true;
                err = info = null;
                $timeout(function() {
                    scope.message = success = null;
                }, 3000);
                tryStopPropagation(ev);
            });

            scope.$on('flash:info', function(ev, msg) {
                scope.message = info = msg;
                scope.visible = true;
                err = success = null;
                tryStopPropagation(ev);
            });

            scope.$on('flash:hide', function() {
                scope.visible = false;
            });
        }
    };
});
})();
